import 'dayjs/locale/en-gb';
import { useMemo, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useReactToPrint } from 'react-to-print';
import worker from '../../assets/images/worker.png';
import { OsPrint } from '../../components/OsPrint/OSPrint';
import Selector from '../../components/Selector';
import { getTotalSum } from '../ModalBudget/utils/functions';
import {
  TabDetails,
  TabReport,
  TabServicesAndParts,
  TabTerm,
} from './components';

// Constantes para as abas
const EXTERNAL_OS_TABS = {
  DETAILS: 0,
  SERVICES_PARTS: 1,
  REPORT: 2,
  TERM: 3,
};

const ModalExternalOS = ({
  values = {},
  client,
  vehicle,
  service,
  aeService,
  parts,
  printCompany,
  consultant,
  checklist,
}) => {
  const [currentTab, setCurrentTab] = useState(EXTERNAL_OS_TABS.DETAILS);
  const [localSignatureData, setLocalSignatureData] = useState(null);
  const [isSignatureReset, setIsSignatureReset] = useState(false);
  const totalSum = useMemo(
    () => getTotalSum(service, parts, aeService),
    [service, parts, aeService]
  );
  const totalServices = useMemo(
    () => getTotalSum(service, [], []),
    [service, aeService]
  );
  const totalAeServices = useMemo(
    () => getTotalSum([], [], aeService),
    [service, aeService]
  );
  const totalParts = useMemo(() => getTotalSum([], parts, []), [parts]);
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onBeforeGetContent: () => {
      const newTitle = `OrdemServico_${values.code}_${values.client_name}_${values.vehicle_name}`;
      document.title = newTitle;
      return Promise.resolve();
    },
    onAfterPrint: () => {
      document.title = 'Prospera';
    },
  });

  const selectedClient = client.find(
    (item) =>
      item.value === values?.client?.value || item.value === values.client
  );
  const selectedVehicle = vehicle.find(
    (item) =>
      item.value === values?.vehicle?.value || item.value === values.vehicle
  );
  const selectedFinancialCoresponsible = client.find(
    (item) =>
      item.value === values?.financial_coresponsible?.value ||
      item.value === values?.financial_coresponsible
  );

  return (
    <>
      {isMobile ? (
        <></>
      ) : (
        <div className="imageExternal">
          <img
            className="backWorkerExternal"
            // eslint-disable-next-line no-undef
            src={worker}
          />
        </div>
      )}
      {/* <Helmet>
        <title>Prospera</title>
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={window.location.pathname + window.location.search}
        />
        <meta property="og:title" content="Prospera" />
        <meta property="og:description" content="Prospera" />
        <meta
          property="og:image"
          content="../../assets/images/worker.png"
        />
      </Helmet> */}
      <div className="eb-container eb-container-print">
        <div className="form">
          <div className="modal-header">
            <div className="header-title">
              <h4 className="modal-title">{'ORDEM DE SERVIÇO'}</h4>
            </div>
            <div className="header-buttons"></div>
          </div>

          {/* Navegação com botões Selector */}
          <div
            style={{
              textAlign: 'center',
              marginBottom: '20px',
              marginTop: '10px',
            }}
          >
            <div className="modal-budget-nav-tabs-container">
              <Selector
                handleClick={() => setCurrentTab(EXTERNAL_OS_TABS.DETAILS)}
                buttonClass={
                  currentTab === EXTERNAL_OS_TABS.DETAILS ? 'highlighted' : ''
                }
                id={'Detalhes'}
                name={'Detalhes'}
              />
              <Selector
                handleClick={() =>
                  setCurrentTab(EXTERNAL_OS_TABS.SERVICES_PARTS)
                }
                buttonClass={
                  currentTab === EXTERNAL_OS_TABS.SERVICES_PARTS
                    ? 'highlighted'
                    : ''
                }
                id={'Serviços/Peças'}
                name={'Serviços/Peças'}
              />
              <Selector
                handleClick={() => setCurrentTab(EXTERNAL_OS_TABS.REPORT)}
                buttonClass={
                  currentTab === EXTERNAL_OS_TABS.REPORT ? 'highlighted' : ''
                }
                id={'Laudo'}
                name={'Laudo'}
              />
              <Selector
                handleClick={() => setCurrentTab(EXTERNAL_OS_TABS.TERM)}
                buttonClass={
                  currentTab === EXTERNAL_OS_TABS.TERM ? 'highlighted' : ''
                }
                id={'Termo'}
                name={'Termo'}
              />
            </div>
          </div>

          {/* Conteúdo das abas */}
          {currentTab === EXTERNAL_OS_TABS.DETAILS && (
            <TabDetails
              values={values}
              selectedClient={selectedClient}
              selectedVehicle={selectedVehicle}
              selectedFinancialCoresponsible={selectedFinancialCoresponsible}
              consultant={consultant}
            />
          )}

          {currentTab === EXTERNAL_OS_TABS.SERVICES_PARTS && (
            <TabServicesAndParts
              service={service}
              aeService={aeService}
              parts={parts}
              values={values}
              totalServices={totalServices}
              totalAeServices={totalAeServices}
              totalParts={totalParts}
              totalSum={totalSum}
              columnsService={columnsService}
              columnsPiece={columnsPiece}
            />
          )}

          {currentTab === EXTERNAL_OS_TABS.REPORT && (
            <TabReport values={values} checklist={checklist} />
          )}

          {currentTab === EXTERNAL_OS_TABS.TERM && (
            <TabTerm
              values={values}
              printCompany={printCompany}
              localSignatureData={localSignatureData}
              setLocalSignatureData={setLocalSignatureData}
              isSignatureReset={isSignatureReset}
              setIsSignatureReset={setIsSignatureReset}
            />
          )}
        </div>
      </div>
      <div style={{ display: 'none' }}>
        <OsPrint
          printWithValues={true}
          bodyshopService={service}
          aeService={aeService}
          parts={parts}
          ref={printRef}
          company={printCompany}
          client={client}
          totalSum={totalSum}
          totalBodyshopService={totalServices}
          totalParts={totalParts}
          values={values}
          totalServices={totalServices + totalAeServices}
          totalAeService={totalAeServices}
          observation={values.observation}
        />
      </div>
    </>
  );
};

export default ModalExternalOS;

export const sizeOptions = [
  // { id: 1, value: "PP", label: "PP" },
  { id: 2, value: 'P', label: 'P' },
  { id: 3, value: 'M', label: 'M' },
  { id: 4, value: 'G', label: 'G' },
  // { id: 5, value: "GG", label: "GG" },
];

export const paymentOptions = [
  { id: 1, value: 'Crédito', label: 'Crédito' },
  { id: 2, value: 'Débito', label: 'Débito' },
  { id: 3, value: 'Dinheiro', label: 'Dinheiro' },
  { id: 4, value: 'Pix', label: 'Pix' },
];

const columnsService = (label, aeService) => [
  {
    id: 1,
    field: 'title',
    label: label,
    width: '1fr',
    className: 'field-description',
    resizable: false,
    cellRenderer: ({ data }) => {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1',
            padding: '8px 0',
          }}
        >
          <div style={{ paddingLeft: '10px' }}>{data.title}</div>
          <div
            style={{
              gap: '5px',
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '10px',
              paddingRight: '10px',
            }}
          >
            <div className="field-actions-budget externalBudget-service-hour">
              {aeService ? data.quantity || 1 : data.time}
            </div>
            <div className="field-actions-budget externalBudget-service-unit">
              {parseFloat(data.unitaryValue || 0).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </div>
            <div className="field-actions-budget externalBudget-service-total">
              {data?.value === 'NaN'
                ? 'R$ 0,00'
                : parseFloat(data?.value || 0).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
            </div>
          </div>

          {data?.services && data?.services?.length > 0 && (
            <>
              <div className="column-service-packages" />
              {data?.services?.map((s) => (
                <div key={s.title} style={{ paddingLeft: '10px' }}>
                  - {s.title}
                </div>
              ))}
            </>
          )}
        </div>
      );
    },
  },
];

const columnsPiece = () => [
  {
    id: 1,
    field: 'name',
    label: 'Relação das Peças',
    width: '1fr',
    className: 'field-description',
    resizable: false,
    cellRenderer: ({ data }) => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1',
          padding: '8px 0',
        }}
      >
        <div style={{ paddingLeft: '10px' }}>{data.name}</div>
        <div
          style={{
            gap: '5px',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          <div className="field-actions-budget externalBudget-piece-quantity">
            {data.quantity}
          </div>
          <div className="field-actions-budget externalBudget-piece-unit">
            {(data?.value && data?.quantity
              ? parseFloat(data.value) / data.quantity
              : data.unitaryValue
            )?.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
          <div className="field-actions-budget externalBudget-piece-total">
            {parseFloat(data.value || 0).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
        </div>
      </div>
    ),
  },
];
